import { DeliveryServiceDescriptionModel } from './../../../service/model/delivery-service-description.model';
import { DeliveryService } from './../../../service/delivery.service';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AbstractComponent } from '../../../definition/abstract/abstract.component';
import { PackageDataModel } from './model/package-data.model';

@Component({
    selector: 'app-package-data',
    templateUrl: './package-data.component.html',
    styleUrls: ['./package-data.component.scss']
})
export class PackageDataComponent extends AbstractComponent implements OnChanges {
    @Input() packageData: PackageDataModel;
    @Input() form: FormGroup;
    @Input() mode = 'select';

    initialized = false;

    public override ngOnInit(): void {
        this.initializeSelectMode();
    }
    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['packageData'] && this.initialized) {
            this.updatePackageDataContent();
        }
    }

    protected initializeSelectMode(): void {
        if (!this.form) {
            this.form = new FormGroup({
                height: new FormControl("28", Validators.required),
                width: new FormControl("19", Validators.required),
                length: new FormControl("19", Validators.required),
                weight: new FormControl("500", Validators.required),
            })
        }

        if (this.packageData) {
            this.updatePackageDataContent();
        }

        this.initialized = true;
    }
    protected updatePackageDataContent(): void {
        this.form.patchValue(this.packageData)
    }
}
